// Traced in the poster's native coordinate space. Apply the same cover
// transform as the ocean canvas so the light stays behind the town at any size.
export const SEASIDE_LIGHT_SOURCE = { width: 1280, height: 720 };

// These closed silhouettes form the black region in a white SVG air mask.
// The large town region deliberately continues below the upper light plane;
// the lamp, rocky island and individual palm fronds remain separate shapes.
export const FOREGROUND_OCCLUSION_PATH = `
  M 0 0 H 420
  C 424 8 432 12 433 21 C 439 20 446 26 447 37
  C 452 35 460 39 463 48 C 475 44 488 51 492 60
  C 498 61 503 71 504 81 L 512 78 L 514 59
  L 540 51 L 558 51 L 568 49 L 579 50 L 582 54
  L 597 54 L 599 51 L 611 53 L 613 66
  L 629 67 L 630 59 L 641 62 L 643 76 L 651 78
  L 649 99 L 666 105 L 677 111 L 707 109 L 720 121
  L 724 159 L 778 185 L 819 180 L 836 183 L 845 177
  L 852 174 L 881 176 L 882 162 L 878 160 L 878 155
  L 907 155 L 909 161 L 905 163 L 906 179
  L 968 212 C 981 202 995 203 1003 218
  C 1018 219 1024 236 1021 247 L 1028 301
  L 1090 340 L 1280 360 V 720 H 0 Z

  M 458 30
  C 448 17 457 2 474 5 C 474 -3 491 -2 494 10
  C 507 -1 519 8 517 17 C 502 14 494 18 491 25
  C 511 21 524 31 522 42 C 508 32 498 31 491 31
  C 505 39 508 52 501 60 C 490 52 486 40 483 33
  C 481 51 471 60 464 56 C 466 43 470 35 474 29
  C 462 34 452 41 450 40 C 450 35 453 32 458 30 Z
  M 477 27 L 489 29 C 491 48 489 61 488 76
  L 480 94 L 473 89 C 480 69 481 48 477 27 Z

  M 582 56 C 582 44 587 34 595 34
  C 595 26 607 24 614 30 C 618 25 626 29 627 35
  C 638 39 638 48 633 55 C 642 59 640 73 631 77
  L 648 101 L 610 91 L 600 62 Z

  M 669 43
  C 673 28 688 22 701 31 C 704 20 719 21 725 30
  C 729 24 742 30 743 39 C 730 34 718 38 714 44
  C 732 41 743 49 747 65 C 732 59 721 51 712 50
  C 722 65 721 79 713 88 C 704 73 704 60 703 52
  C 699 69 689 81 679 80 C 681 63 689 51 696 47
  C 682 50 674 58 668 57 C 667 52 667 46 669 43 Z
  M 698 44 L 710 45 C 710 68 705 89 701 108
  L 706 126 L 691 134 L 687 124 C 696 91 700 68 698 44 Z

  M 617 128
  C 619 115 636 106 651 113 C 653 102 670 100 680 108
  C 688 98 710 107 713 119 C 727 115 736 127 735 139
  C 744 150 741 169 732 174 C 723 161 711 150 698 146
  C 718 162 720 184 710 194 C 696 179 687 164 681 149
  C 674 172 663 184 650 182 C 648 169 654 153 660 143
  C 644 149 632 162 620 159 C 619 151 624 141 633 136
  C 626 140 615 140 612 137 C 612 134 614 131 617 128 Z
  M 661 137 L 685 140 C 683 186 682 230 681 274
  L 685 314 L 659 319 C 663 280 663 225 661 137 Z

  M 759 127
  C 761 113 775 105 790 111 C 790 99 805 93 818 98
  C 825 101 831 108 830 113 C 845 108 859 119 858 132
  C 868 141 864 161 856 166 C 850 151 839 141 826 137
  C 840 153 838 174 827 179 C 817 167 812 151 809 140
  C 802 157 790 170 779 169 C 775 153 783 141 791 132
  C 776 137 767 147 760 145 C 757 140 757 133 759 127 Z
  M 802 132 L 815 135 C 810 167 803 186 790 211
  L 784 245 L 767 237 C 775 205 794 170 802 132 Z

  M 1101 166
  C 1108 161 1111 161 1115 158 C 1112 150 1118 142 1125 145
  L 1135 147 L 1132 113 L 1135 87 L 1125 84 L 1125 79
  L 1133 76 L 1133 64 L 1129 62 L 1138 53 L 1146 47
  L 1146 44 L 1152 44 L 1152 48 L 1164 58 L 1170 62
  L 1167 65 L 1166 78 L 1174 81 L 1174 86 L 1165 89
  L 1172 159 C 1185 153 1200 155 1202 169
  L 1212 171 L 1225 237 L 1238 258 L 1250 269
  C 1200 283 1119 279 1046 274 L 1060 214 L 1081 186 Z

  M 1077 131
  C 1073 124 1083 116 1090 118 C 1088 112 1096 107 1102 112
  C 1113 109 1122 117 1121 122 C 1111 119 1106 122 1102 126
  C 1114 125 1122 133 1119 140 C 1112 137 1105 129 1101 129
  C 1101 141 1098 148 1093 148 L 1092 135
  C 1087 143 1081 142 1079 139 C 1080 133 1086 127 1091 126
  C 1083 127 1078 133 1077 131 Z
  M 1094 127 L 1101 127 L 1099 177 L 1091 178 Z
`;

// The far pass is projected only on the background hillside. The foreground
// air mask is applied as well, so palms and the lighthouse still occlude it.
export const DISTANT_HILL_PATH = `
  M 731 180 L 728 110 C 734 100 736 91 747 83
  C 756 72 769 66 780 68 C 790 60 802 63 811 71
  C 820 63 832 66 839 74 C 849 67 859 71 867 78
  C 876 73 886 77 893 84 C 902 76 914 82 919 90
  C 930 87 944 94 947 103 C 959 98 971 108 975 118
  C 989 111 1002 126 1007 135 C 1020 127 1035 136 1041 147
  C 1060 145 1070 157 1090 164 L 1090 184 Z
`;
